<template>
  <!-- Calculate height to account for padding and button -->
  <div id="genesys-support-center" class="w-full h-[calc(60vh-100px)] overflow-auto rounded-lg bg-white"></div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue';

declare global {
  interface Window {
    Genesys?: any;
  }
}
const initializeGenesys = (): Promise<void> => {
  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = `
      (function (g, e, n, es, ys) {
        g['_genesysJs'] = e;
        g[e] = g[e] || function () {
          (g[e].q = g[e].q || []).push(arguments)
        };
        g[e].t = 1 * new Date();
        g[e].c = es;
        ys = document.createElement('script'); ys.async = 1; ys.src = n; ys.charset = 'utf-8'; document.head.appendChild(ys);
      })(window, 'Genesys', 'https://apps.mypurecloud.com/genesys-bootstrap/genesys.min.js', {
        environment: 'use1',
        deploymentId: '8b8e5786-b836-4f7e-9412-2c67f255bacc'
      })
    `;

    script.onload = () => {
      setTimeout(() => {
        if (window.Genesys) {
          resolve();
        }
      }, 1000);
    };

    document.head.appendChild(script);
  });
};

const mountKnowledgePortal = async () => {
  try {
    await initializeGenesys();

    await new Promise(resolve => setTimeout(resolve, 500));

    window.Genesys("command", "Database.configure", {
      container: "#genesys-support-center",
      mode: "embedded",
      displayStyle: "modal",
      width: "100%",
      height: "100%",
      // Add size constraints to match modal
      size: {
        width: "100%",
        height: "100%",
        maxWidth: "100%",
        maxHeight: "100%"
      }
    });

    console.log("Knowledge portal initialized in modal");
  } catch (error) {
    console.error("Error mounting knowledge portal:", error);
  }
};

onMounted(async () => {
  await mountKnowledgePortal();
});

onUnmounted(() => {
  if (window.Genesys) {
    try {
      window.Genesys("command", "Database.close");
      const script = document.querySelector('script[src*="genesys-bootstrap"]');
      if (script) {
        script.remove();
      }
      delete window.Genesys;
    } catch (error) {
      console.error("Error cleaning up:", error);
    }
  }
});
</script>

<style>
/* Make sure the content fits and scrolls properly */
#genesys-support-center {
  width: 100% !important;
  max-width: 100% !important;
  overflow: auto !important;
}

#genesys-support-center > div,
#genesys-support-center iframe {
  width: 100% !important;
  max-width: 100% !important;
  border: none !important;
  margin: 0 !important;
  padding: 0 !important;
}

/* Ensure scrollbars appear when needed */
#genesys-support-center::-webkit-scrollbar {
  width: 8px;
}

#genesys-support-center::-webkit-scrollbar-track {
  background: #f1f1f1;
}

#genesys-support-center::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

#genesys-support-center::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>